import { useState } from 'react';
import { startSignIn } from './imsClient';

interface Props {
  /** Optional reason shown to the user (e.g. "your session expired"). */
  reason?: string;
  /** Where to land after the round-trip completes. Defaults to `/`. */
  returnTo?: string;
}

export function SignInScreen({ reason, returnTo = '/' }: Props): JSX.Element {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSignIn(): Promise<void> {
    setBusy(true);
    setError(null);
    try {
      await startSignIn(returnTo);
    } catch (e) {
      setBusy(false);
      setError(e instanceof Error ? e.message : 'Could not start sign-in.');
    }
  }

  return (
    <div className="signin-modal">
      <div className="signin-card">
        <h2>Adobe LLM Monitoring</h2>
        <p className="signin-subtitle">
          Sign in with your Adobe account to access the dashboard. Available to all{' '}
          <code>@adobe.com</code> users.
        </p>
        {reason && <p className="signin-reason">⚠ {reason}</p>}
        <button
          type="button"
          onClick={handleSignIn}
          className="signin-button"
          disabled={busy}
        >
          {busy ? 'Redirecting…' : 'Sign in with Adobe'}
        </button>
        {error && <p className="signin-error">{error}</p>}
      </div>
    </div>
  );
}
